import { render, staticRenderFns } from "./ConfigManagementReport.vue?vue&type=template&id=5aaa2f4a&scoped=true"
import script from "./ConfigManagementReport.vue?vue&type=script&lang=js"
export * from "./ConfigManagementReport.vue?vue&type=script&lang=js"
import style0 from "./ConfigManagementReport.vue?vue&type=style&index=0&id=5aaa2f4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa2f4a",
  null
  
)

export default component.exports